"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.simpleCircuit = simpleCircuit;
exports.deepCircuit = deepCircuit;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(runUnit),
    _marked2 =
/*#__PURE__*/
_regenerator.default.mark(runUnits),
    _marked3 =
/*#__PURE__*/
_regenerator.default.mark(simpleCircuit),
    _marked4 =
/*#__PURE__*/
_regenerator.default.mark(deepCircuit);
/**
 *
 * @param {{pattern: String, task: Function}} unit
 */


function runUnit(_ref) {
  var pattern, task, result;
  return _regenerator.default.wrap(function runUnit$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          pattern = _ref.pattern, task = _ref.task;
          _context.next = 3;
          return (0, _effects.take)(pattern);

        case 3:
          result = _context.sent;
          _context.next = 6;
          return (0, _effects.call)(task, result);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
/**
 *
 * @param {{pattern: String, task: Function}[]} units
 */


function runUnits() {
  var units,
      _iteratorNormalCompletion,
      _didIteratorError,
      _iteratorError,
      _iterator,
      _step,
      unit,
      _args2 = arguments;

  return _regenerator.default.wrap(function runUnits$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          units = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context2.prev = 4;
          _iterator = units[Symbol.iterator]();

        case 6:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context2.next = 13;
            break;
          }

          unit = _step.value;
          _context2.next = 10;
          return (0, _effects.call)(runUnit, unit);

        case 10:
          _iteratorNormalCompletion = true;
          _context2.next = 6;
          break;

        case 13:
          _context2.next = 19;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context2.t0;

        case 19:
          _context2.prev = 19;
          _context2.prev = 20;

          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }

        case 22:
          _context2.prev = 22;

          if (!_didIteratorError) {
            _context2.next = 25;
            break;
          }

          throw _iteratorError;

        case 25:
          return _context2.finish(22);

        case 26:
          return _context2.finish(19);

        case 27:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this, [[4, 15, 19, 27], [20,, 22, 26]]);
}
/**
 * The flow is simple:
 * - wait for a trigger (handles take(unit.pattern) effect)
 * - execute task (handles call(unit.task, result))
 * - and repeat the same steps for next unit
 *
 * const UnitShape = {
 *    pattern: {String|Array|Function} - pattern for the take effect
 *    task: Function - receives result of the above take effect as first argument
 * }
 * @param  {{pattern: String, task: Function}[]} units
 */


function simpleCircuit() {
  var units,
      _args3 = arguments;
  return _regenerator.default.wrap(function simpleCircuit$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          units = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : [];

        case 1:
          if (!true) {
            _context3.next = 6;
            break;
          }

          _context3.next = 4;
          return runUnits(units);

        case 4:
          _context3.next = 1;
          break;

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
/**
 * First unit is executed,
 * then all the units from index 1, to last index - 2,
 * if during exucution of those intermediate units
 * is triggered pattern of last unit, the intermediate units are cancelled
 * and task of the last unit is executed.
 * @param  {{pattern: String, task: Function}[]} units
 */


function deepCircuit() {
  var units,
      firstUnit,
      intermediateUnits,
      lastUnit,
      result,
      _args4 = arguments;
  return _regenerator.default.wrap(function deepCircuit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          units = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : [];

          if (!(units.length < 3)) {
            _context4.next = 3;
            break;
          }

          throw new Error("The 'units' array must include at least 3 units, not only ".concat(units.length, " unit/s."));

        case 3:
          firstUnit = units[0];
          intermediateUnits = units.slice(1, units.length - 1);
          lastUnit = units[units.length - 1];

        case 6:
          if (!true) {
            _context4.next = 16;
            break;
          }

          _context4.next = 9;
          return runUnit(firstUnit);

        case 9:
          _context4.next = 11;
          return (0, _effects.race)({
            deepUnits: (0, _effects.call)(simpleCircuit, intermediateUnits),
            lastUnitResult: (0, _effects.take)(lastUnit.pattern)
          });

        case 11:
          result = _context4.sent;
          _context4.next = 14;
          return (0, _effects.call)(lastUnit.task, result.lastUnitResult);

        case 14:
          _context4.next = 6;
          break;

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}